module.exports = __webpack_public_path__ + "static/media/e-vahan-logo.e97bca71.png";